import { makeCall } from '../api.js';

export function fetchBrands() {
    return makeCall({
        method: 'GET',
        action: 'maintenance'
    });   
}

export function fetchCatalog(brandId) {
    return makeCall({
        method: 'GET',
        action: `maintenance?brandId=${brandId}`
    });
}

export function fetchModifications(modelId) {
    return makeCall({
        method: 'GET',
        action: `maintenance?modelId=${modelId}`
    });
}

export function fetchMaintenanceDetails(modificationId) {
    return makeCall({
        method: 'GET',
        action: `maintenance?modificationId=${modificationId}`
    });
}



/** WEBPACK FOOTER **
 ** ./src/logic/api/catalog.js
 **/